var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIconLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-icon",
    transform: "translate(-565 -461)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 48,
    height: 48,
    transform: "translate(565 461)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    d: "M17,17V5h4V17H33v4H21V33H17V21H5V17Z",
    transform: "translate(570 466)",
    fill: "#a6b8bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconLarge);
export default __webpack_public_path__ + "static/media/add-icon-large.bc3d1f4d49edf6290f012d714fa868f2.svg";
export { ForwardRef as ReactComponent };